var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TypeBody',{staticClass:"no-payrolls rounded-md border border-gray-5 flex items-center justify-center p-4",attrs:{"variant":"text-small"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }